import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CustomerFormComponent } from "./customer/components/customer-form/customer-form.component";
import { CustomerListComponent } from "./customer/components/customer-list/customer-list.component";
import { ListboxModule } from "primeng/listbox";
import { SidebarModule } from "primeng/sidebar";
import { TabsModule } from "ngx-bootstrap/tabs";
import { SharedModule } from "@app/modules/shared/shared.module";
import { VirtualOrderReceiptListComponent } from "./virtual-order-receipt/components/virtual-order-receipt-list/virtual-order-receipt-list.component";
import { VirtualOrderReceiptFormComponent } from "./virtual-order-receipt/components/virtual-order-receipt-form/virtual-order-receipt-form.component";
import { VirtualOrderReceiptDetailFilterComponent } from "./virtual-order-receipt/components/virtual-order-receipt-detail-filter/virtual-order-receipt-detail-filter.component";
import { CustomerDetailFilterComponent } from "./customer/components/customer-detail-filter/customer-detail-filter.component";

@NgModule({
  imports: [
    CommonModule,
    ListboxModule,
    SidebarModule,
    TabsModule,
    SharedModule.forRoot(),
  ],
  declarations: [
    CustomerFormComponent,
    CustomerListComponent,
    VirtualOrderReceiptListComponent,
    VirtualOrderReceiptFormComponent,
    VirtualOrderReceiptDetailFilterComponent,
    CustomerDetailFilterComponent,
  ],
  exports: [
    CustomerFormComponent,
    CustomerListComponent,
    VirtualOrderReceiptListComponent,
    VirtualOrderReceiptFormComponent,
    VirtualOrderReceiptDetailFilterComponent,
  ],
})
export class ShippingManagementModule {}
